import { apiClient } from '@/utils/httpClient';

export type McpPlatformOverview = {
  gatewayHealth: string;
  dnsStatus: string;
  gatewayUrl: string;
  portalMcpUrl: string;
  activeTenants: number;
  totalTenants: number;
  catalogVersion: string;
  infrastructure: {
    route53Record: string;
    acmCertificateExpiry: string | null;
    customDomainStatus: string;
  };
  recentEvents: Array<{ at: string; message: string }>;
};

export type McpTenantFeature = {
  tenantId: string;
  displayName: string;
  mcpEnabled: boolean;
  catalogVersion: string;
  rolloutPhase: string;
  lastToolCallAt: string | null;
  notes: string;
};

export type McpOAuthClientConfig = {
  clientId: string;
  clientSecretMasked: string;
  redirectUris: string[];
  scopes: string[];
};

export type McpGlobalLimits = {
  dailyToolCallsPerTenant: number;
  maxConcurrentSessionsPerTenant: number;
  maxToolOutputKb: number;
  t3WriteRequiresItsmApproval: boolean;
};

export const portalMcpApi = {
  getOverview: () => apiClient.get<McpPlatformOverview>('/admin/mcp/overview'),
  listTenants: (search?: string) => {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return apiClient.get<{ tenants: McpTenantFeature[] }>(`/admin/mcp/tenants${q}`);
  },
  updateTenant: (tenantId: string, body: Partial<Pick<McpTenantFeature, 'mcpEnabled' | 'rolloutPhase' | 'notes'>>) =>
    apiClient.put<McpTenantFeature>(`/admin/mcp/tenants/${encodeURIComponent(tenantId)}`, body),
  getOAuthClients: () => apiClient.get<McpOAuthClientConfig>('/admin/mcp/oauth-clients'),
  putOAuthClients: (body: { redirectUris?: string[]; rotateSecret?: boolean }) =>
    apiClient.put<McpOAuthClientConfig>('/admin/mcp/oauth-clients', body),
  getLimits: () => apiClient.get<McpGlobalLimits>('/admin/mcp/limits'),
  putLimits: (body: McpGlobalLimits) => apiClient.put<McpGlobalLimits>('/admin/mcp/limits', body),
};
